import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import { Profile } from "types/Profile";

const processOptions = (options: Profile[]) =>
  options.map(({ id, username }) => ({
    value: id,
    label: username,
  }));

function ProfileSelect(props: any) {
  return (
    <RemoteSelect url="profiles" processOptions={processOptions} {...props} />
  );
}

export default ProfileSelect;
